import { IconButton } from '@material-ui/core';
import { colors, fonts } from '~/layout';
import * as lib from '~/dependencies';

export const Container = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: ${colors.white};
  overflow: hidden!important;
`;

export const Content = lib.styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  padding: 10px 15px 10px 15px;
  flex-direction: column;
  &::-webkit-scrollbar { width: 0!important }
  overflow: -moz-scrollbars-none!important; }
  -ms-overflow-style: none!important; }
`;

export const HeaderControls = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  button {
    background-color: transparent!important;
    text-transform: none;
    padding: 0!important;
    width: auto!important;
    min-width: auto!important;
    font-size: ${fonts.default}px;
    font-weight: 800;
    color: ${colors.black}!important;
    opacity: 0.5;

    &:hover {
      background-color: transparent!important;
    }

    &:last-child {
      margin-left: 15px;
    }
  }

  .active {
    color: ${colors.lightBlue}!important;
    margin-left: 15px;
  }
`;

export const IconButtonComponent = lib.styled(IconButton)`
  .call-icon {
    ellipse {
      fill: ${(props: any) =>
        props.disable ? colors.lightGray02 : colors.green02}!important;
    }
  }
  
  .video-icon {
    circle {
      fill: ${(props: any) =>
        props.disable ? colors.lightGray02 : '#00aeef'}!important;
    }

    margin-top: 8px;
  }
`;

export const ActionStar = lib.styled.div`
  pointer-events: ${(props: any) => (props.loading ? 'none' : 'visible')};
  opacity: ${(props: any) => (props.loading ? '0.4' : '1')};
  max-height: 20px;
  margin-right: 0px;
  cursor: pointer;

  .icon {
    max-height: 20px;
    color: ${(props: any) =>
      props.active ? colors.green03 : colors.lightGray06};
  }

  &:hover {
    .icon {
      color: ${colors.green03};
    }
  }
`;

export const ActionGroup = lib.styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
